import { Color } from 'shared/utils/colors';

export enum Process {
  HS = 'PROCESS_HS',
  QA = 'PROCESS_QA',
  ENV = 'PROCESS_ENV',
  TSK = 'PROCESS_TSK',
  MS = 'PROCESS_MS',
  MSC = 'PROCESS_MSC',
  MSS = 'PROCESS_MSS',
  MSE = 'PROCESS_MSE',
  RFI = 'PROCESS_RFI',
  CO = 'PROCESS_CO',
  NO = 'PROCESS_NO',
  ACC = 'PROCESS_ACC',
  DS = 'PROCESS_DS',
}

export const AVAILABLE_PROCESSES = [
  { _id: Process.QA, label: 'process_Quality' as const },
  { _id: Process.ENV, label: 'process_Env' as const },
  { _id: Process.HS, label: 'process_H&S' as const },
  { _id: Process.TSK, label: 'process_Tsk' as const },
  { _id: Process.MS, label: 'process_MaterialSubmittal' as const },
  { _id: Process.MSC, label: 'process_MaterialSubmittalConstruction' as const },
  { _id: Process.MSS, label: 'process_MaterialSubmittalSanitary' as const },
  { _id: Process.MSE, label: 'process_MaterialSubmittalElectrical' as const },
  { _id: Process.RFI, label: 'process_RequestForInformation' as const },
  { _id: Process.CO, label: 'process_ChangeOrder' as const },
  { _id: Process.NO, label: 'process_Note' as const },
  { _id: Process.ACC, label: 'process_Accident' as const },
  { _id: Process.DS, label: 'process_DesignDocumentSubmittal' as const },
];

export const ALL_PROCESS_CODES = [
  Process.HS,
  Process.QA,
  Process.ENV,
  Process.TSK,
  Process.MS,
  Process.MSC,
  Process.MSS,
  Process.MSE,
  Process.RFI,
  Process.CO,
  Process.NO,
  Process.ACC,
  Process.DS,
];

export function isProcessValue(value: string): value is Process {
  return ALL_PROCESS_CODES.some((candidate) => candidate === value);
}

export interface ProcessType {
  _id: Process;
  label: string;
  code: string;
  icon?: string;
  color: Color;
  userHasAccess: boolean;
  currentInitialFormVersion: number;
  workflowId: string;
}
